import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { IMAGES, scrollToBuy } from '../utils/constants';
const HIGHLIGHTS = ['1 Main Box Set', '5 Strategic Bonuses', '6 Complete Modules', 'All Experience Levels', 'Studio, Private & Online Classes'];
export function Hero() {
  return <header className="w-full bg-ivory" data-id="element-115" data-mp="129h6c3bjvskt">
      <div className="mx-auto flex max-w-3xl flex-col items-center px-4 py-7 text-center sm:px-6 lg:py-10" data-id="element-116" data-mp="128607wumu8qj">
        <span className="mb-3 inline-flex items-center gap-2 rounded-full border border-brand/30 bg-brand/10 px-3 py-1.5 font-head text-[10px] font-bold uppercase tracking-wider text-brand-dark sm:text-xs" data-id="element-117" data-mp="xaxg3qpxbumn">
          <span className="h-1.5 w-1.5 rounded-full bg-brand" aria-hidden="true" data-id="element-118" data-mp="nbygsyr1tbcb" />
          The #1 Ready-To-Teach System For Yoga Instructors
        </span>

        <h1 className="font-head text-3xl font-extrabold uppercase leading-[1.05] text-charcoal sm:text-4xl lg:text-5xl" data-id="element-119" data-mp="381xjaspbqs7j">
          Have your next yoga class ready{' '}
          <span className="text-brand" data-id="element-120" data-mp="3o7lshs6gf8ph">in under 5 minutes.</span>
        </h1>

        <p className="mt-3 max-w-2xl text-sm leading-snug text-softgray sm:text-base" data-id="element-121" data-mp="3o6u5h5qxajat">
          Your complete 6-in-1 yoga teaching system: ready-to-teach classes, structured sequences,
          class-building tools, pose guidance, student resources, and professional instructor
          templates.
        </p>

        <button type="button" onClick={scrollToBuy} className="mt-4 block w-full transition hover:opacity-95" aria-label="Get Yoga Teaching Vault now" data-id="element-122" data-mp="30g6kbirzxx6b">
          <img src={IMAGES.boxSet} alt="Yoga Teaching Vault complete 6-in-1 box set with six modules and five bonuses" className="mx-auto w-full max-w-2xl" loading="eager" data-id="element-123" data-mp="2qi0lja1hl75o" />
        </button>

        <ul className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1.5" data-id="element-124" data-mp="2ljpbozb6ywng">
          {HIGHLIGHTS.map(item => <li key={item} className="flex items-center gap-1.5 font-head text-xs font-semibold text-charcoal sm:text-sm" data-id="element-125" data-mp="s3mb9x0ezovq">
              <CheckCircle2Icon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-126" data-mp="ibgn6yda9rlt" />
              {item}
            </li>)}
        </ul>

        <div className="mt-5 flex w-full flex-col items-center" data-id="element-127" data-mp="db2fjhflgjob">
          <CtaButton data-id="element-128" data-mp="1azkvzsr5iksq" />
          <TrustRow className="mt-3" data-id="element-129" data-mp="1ayt9d7fj7xel" />
        </div>
      </div>
    </header>;
}